module.exports = __webpack_public_path__ + "img/selected2-min.be091807.png";